import { Component } from '@opten/gin-tonic/helpers/compiler';
import { MapExtended } from '@opten/gin-tonic/components/map-extended/index';

// declare const Cookiebot;
@Component({ className: 'js-map-extended' })
export class MapExtendedComponent {
	private mapExtended: MapExtended;
	constructor(private element: HTMLElement) {

		const lat = this.element.getAttribute('data-map-center-lat') ?? "";
		const lng = this.element.getAttribute('data-map-center-lng') ?? "";
		const zoom = this.element.getAttribute('data-zoom') ?? "";
		const apiKey = this.element.getAttribute('data-map-key');
		const nonce = this.element.getAttribute('data-nonce');

        this.mapExtended = new MapExtended(element, {
			mapCenter: {lat: parseFloat(lat), lng: parseFloat(lng)},
			zoom: parseFloat(zoom),
			mapStyles: [
				{
					"featureType": "administrative",
					"stylers": [
						{
							"visibility": "off"
						}
					]
				},
				{
					"featureType": "poi",
					"stylers": [
						{
							"visibility": "off"
						}
					]
				},
				{
					"featureType": "transit",
					"stylers": [
						{
							"visibility": "off"
						}
					]
				}
			],
			styledMapName: 'AG',
			mapApiKey: apiKey,
			nonce: nonce
		});
	}

	private getMapStyles() {
		return [
			{
				"featureType": "administrative",
				"stylers": [
					{
						"visibility": "off"
					}
				]
			},
			{
				"featureType": "poi",
				"stylers": [
					{
						"visibility": "off"
					}
				]
			},
			{
				"featureType": "transit",
				"stylers": [
					{
						"visibility": "off"
					}
				]
			}
		];
	}
}
